/**
 * HR app routes.
 * HR lives at /hr with two sub-sections: /hr/employees (HR Management)
 * and /contacts (Address Book, existing).
 */
const hrRoutes = [
  {
    path: "/hr",
    name: "HrHome",
    component: () => import("@/views/hr/HrHome.vue"),
    meta: { requiresAuth: true, app: "hr" },
  },
  {
    path: "/hr/employees",
    name: "HrEmployees",
    component: () => import("@/views/hr/HrEmployeesHome.vue"),
    // "hr" is the grantable code today; "hr-management" is retired but older
    // accounts still hold it (2026-09-10 — an hr-only user was refused here).
    meta: { requiresAuth: true, app: ["hr", "hr-management"] },
  },
  {
    // Monthly payroll runs (PAYROLL_PLAN.md): Bal (hr-payroll) captures the
    // variable pay amounts; accounting/gl admins post the accrual + WPS payment.
    path: "/hr/payroll",
    name: "HrPayroll",
    component: () => import("@/views/hr/PayrollHome.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: ["hr-payroll", "accounting", "gl"] },
  },
];

export default hrRoutes;
